import { useAuthContext } from "../contexts/Auth";
import { useSnackContext } from "../contexts/Snack";
import { callActionDialog } from "../services/ApiService";
import Swal from 'sweetalert2';

export const useAction = ({ action, message, caption }) => {

  const { auth } = useAuthContext();
  const snack = useSnackContext();

  const exec = () => {
    Swal
    .fire({
      icon: 'question',
      title: caption,
      html: message,
      showCancelButton: true,
      confirmButtonText: 'Ejecutar',
      cancelButtonText: 'Cerrar',
    })
    .then((result) => {
      if (result.isConfirmed) {
        snack.openSuccess(caption);
        callActionDialog(action, auth.token)
          .then( response => {
            snack.openSuccess(response.data.result);
          })
          .catch( error => {
            //va a entrar aca por timeout
            //snack.openAxiosError(error)
          })
      }
    });

  }

  return { exec };

}